<template lang="pug">
  div.payment.payment-bill-update.without-tabs
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                e-form-group(
                  label="Тип"
                  name="_bill_type"
                  inputType="select"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                  :options="billTypes"
                  @change="resetFieldsOnChangeBillType()"
                )

                e-form-group(
                  name="operation_day"
                  inputType="calendar"
                  label="Операционный день"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )

                e-form-group(
                  name="pay_day"
                  inputType="calendar"
                  label="Дата оплаты"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )

                e-form-group(
                  name="peny"
                  inputType="checkbox"
                  caption="Пени"
                  :model="fields"
                  tabView="tab1"
                ).no-min-height

                e-form-group(
                  name="value"
                  label="Сумма к оплате"
                  :model="fields"
                  tabView="tab1"
                  validationRule="double"
                  :required="true"
                )

                e-form-group(
                  name="saldo"
                  inputType="checkbox"
                  caption="Разнести пропорционально входящему сальдо"
                  :model="fields"
                  tabView="tab1"
                ).no-min-height

              div.col
                template(
                  v-if="fields._bill_type == BILL_TYPE_NAME"
                )
                  e-form-group(
                    tabView="tab1"
                    inputType="suggestion"
                    label="Собственник"
                    name="_ownerName"
                    realName="_owner_id"
                    :model="fields"
                    :suggestionEndpoint="suggestionOwnerEndpoint"
                    :transformSuggestions="transformOwnerSuggestions"
                    @selectItem="selectOwnerItem"
                    :required="true"
                    placeholder="Начните вводить название..."
                  )
                  e-progress(
                    v-if="loadingOwner"
                    :loading="true"
                  )
                  e-form-group(
                    v-if="fields._owner_id && !loadingOwner"
                    inputType="suggestion[]"
                    name="account_ids"
                    label="Лицевые счета"
                    :model="fields"
                    tabView="tab1"
                    :options="ownerBankBooks"
                    placeholder="начните вводить номер лс..."
                    :required="true"
                    :useInnerSearch="true"
                  )

                template(
                  v-else-if="fields._bill_type == BILL_TYPE_NUMBER"
                )
                  e-form-group(
                    inputType="suggestion[]"
                    name="account_ids"
                    label="Лицевые счета"
                    :model="fields"
                    tabView="tab1"
                    :suggestionEndpoint="suggestionLegalsEndpoint"
                    :transformSuggestions="transformLegalsSuggestions"
                    :minSuggestLen="2"
                    placeholder="начните вводить номер лс..."
                    :required="true"
                    :useInnerSearch="false"
                  )

                e-form-group(
                  name="period"
                  inputType="calendar"
                  label="Расчетный период"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                  valueFormat="yyyy-MM"
                  format="MM/yyyy"
                  type="month"
                )

                e-form-group(
                  name="agent_id"
                  inputType="select"
                  :options="payAgents"
                  label="Платежный агент"
                  :model="fields"
                  tabView="tab1"
                )

                e-form-group(
                  name="comment"
                  label="Основание"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )

</template>

<script>
  import paymentBillFormMixin from './mixins/payment-bill-form'
  import {payment, core} from "../../api/api-endpoints"

  export default {
    mixins: [paymentBillFormMixin],
    title () {
      return 'Добавление платежа'
    },
    methods: {
      getUpdateOrCreateUrl () {
        return payment.paymentBillCreate()
      },
      getCollectionEndpoint () {
        return core.collection('pay_agent')
      }
    }
  }
</script>
